import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * open-link Icon from Figma
 * @link [Figma](https://www.figma.com/design/bbV5fb5jWhJHEbAUH2cC9f/Matching?node-id=1433-65320)
 * */
const ExternalLinkIcon = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path className="fill-current" d="M10.125 9.75V9.375C10.125 9.16789 10.2929 9 10.5 9C10.7071 9 10.875 9.16789 10.875 9.375V9.75C10.875 10.3713 10.3713 10.875 9.75 10.875H2.25C1.63011 10.875 1.12501 10.3749 1.125 9.7522V2.24854C1.125 1.62602 1.62987 1.125 2.25 1.125H2.625C2.83211 1.125 3 1.29289 3 1.5C3 1.70711 2.83211 1.875 2.625 1.875H2.25C2.0417 1.875 1.875 2.04262 1.875 2.24854V9.7522C1.87501 9.95788 2.04148 10.125 2.25 10.125H9.75C9.95711 10.125 10.125 9.95711 10.125 9.75Z" />;
    t1 = <path className="fill-current" d="M10.875 5.625C10.875 5.83211 10.7071 6 10.5 6C10.2929 6 10.125 5.83211 10.125 5.625V2.36792L4.38208 7.77319C4.23126 7.91511 3.99374 7.90789 3.85181 7.75708C3.70988 7.60626 3.71711 7.36874 3.86792 7.22681L9.55444 1.875H6.375C6.16789 1.875 6 1.70711 6 1.5C6 1.29289 6.16789 1.125 6.375 1.125H10.5C10.7071 1.125 10.875 1.29289 10.875 1.5V5.625Z" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default ExternalLinkIcon;